import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './../../assets/styles/constants.css';
import './../../assets/styles/fonts.css';
import './SampleSize.css';

const DEFAULT_THRESHOLD = 1000;

const SampleSize = ({ population, threshold, pinRight }) => {
  if (!population) return <p>Calculating...</p>;

  const isSufficientPop = population >= threshold;
  const mainClass = classnames('sample-size', {
    'sample-size--pin-right': pinRight
  });
  const chartStyle = classnames('fa fa-bar-chart', {
    'sample-size__icon--sufficient': isSufficientPop,
    'sample-size__icon--insufficient': !isSufficientPop
  });
  const label = isSufficientPop ? 'Sufficient' : '';

  return (
    <div className={mainClass}>
      <i className={`fa fa-bar-chart sample-size__icon ${chartStyle}`} />
      <div className="sample-size__info">
        {label && <div className="sample-size__label">{label}</div>}
        <div className="sample-size__population-count">
          {`n = ${numeral(population).format('0.00a')}`}
        </div>
      </div>
    </div>
  );
};

SampleSize.propTypes = {
  population: PropTypes.number.isRequired,
  threshold: PropTypes.number,
  pinRight: PropTypes.bool
};

SampleSize.defaultProps = {
  threshold: DEFAULT_THRESHOLD,
  pinRight: false
};

export default SampleSize;
